<div class="alert alert-danger mt-2" role="alert" *ngIf="mensagemErro" (close)="fecheMensagemErro()" dismissible>
  <i class="k-icon k-i-error"></i> {{mensagemErro}}
  <button type="button" class="close" data-dismiss="alert" aria-label="Fechar">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<form id="frm" [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}"
      novalidate #frm="ngForm" data-pagarmecheckout-form>
  <div class="bloqueio" *ngIf="carregando || carregando3ds || carregandoScript3ds" >
    <div class="k-icon k-i-loading mt-5 centralizado fa-2x"  ></div>
  </div>
  <ng-container *ngIf="!carregando && cartoesSalvos.length">
    <div class="row" >
      <div class="col-12">
        <div class="form-group">

          <label class="d-flex justify-content-between align-items-center">
            <div class="label">
              <!--<i class="fas fa-credit-card mr-1"></i>-->
              Meus cartões
            </div>

            <button class="btn btn-sm btn-outline-blue" style="  width: 120px;" type="button" (click)="escolherNovoCartao()">
              <i class="fas fa-plus mr-1"></i> Novo cartão
            </button>

          </label>


          <kendo-combobox name="cartaoSalvoSelecionado"
                          [data]="cartoesSalvos"
                          [textField]="'descricaoPagamento'"
                          [valueField]="'id'"
                          [valuePrimitive]="false"
                          [(ngModel)]="cartaoSalvoSelecionado"
                          placeholder="Selecione um cartão"
                          class="form-control"
                          (valueChange)="escolherCartaoSalvo($event)">
          </kendo-combobox>
        </div>
      </div>
    </div>
    <!--<div class="row" >
      <div class="col-12 col-sm-6" *ngIf="cartaoSalvoSelecionado">
        <div class="form-group">
          <label for="cvvCartaoSalvo">Código de segurança (CVV)</label>
          <input type="text" class="form-control" autocomplete="off" [mask]="'0009'" placeholder="opcional"
                 id="cvvCartaoSalvo" name="cvvCartaoSalvo"
                 [(ngModel)]="cartaoSalvoSelecionado.cvvCartaoSalvo" #cvvCartaoSalvo="ngModel"
                 [required]="exigirCvvCartaoSalvo">
          <div class="invalid-feedback">
            <p *ngIf="cvvCartaoSalvo.errors?.required">Obrigatório</p>
          </div>
        </div>
      </div>
    </div> -->
  </ng-container>

  <div class="row" *ngIf="!cartaoSalvoSelecionado">
    <div class="col-12 col-sm-8" >
      <div class="form-group ">
        <label for="numero">Número do cartão</label>

        <input type="text" class="form-control input-background" autocomplete="off"  [mask]="'0000-0000-0000-0009'" style="font-family: monospace;"
               id="numero" name="numero" [(ngModel)]="cartao.numero" #numero="ngModel" #numeroElem appAutoFocus
               required (ngModelChange)="alterouNumeroCartao()"  data-pagarmecheckout-input>


        <i class="fa fa-credit-card fa-2x" *ngIf="!paymentMethod"
           [ngClass]="{ 'text-muted': !cartao.bandeira,  ' text-success': cartao.bandeira && cartao.numeroValido}" > </i>


        <div class="invalid-feedback">
          <p *ngIf="numero.errors?.required">Obrigatório</p>
          <p *ngIf="numero.errors?.mask">Número do cartão de crédito inválido.</p>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-4" >
      <div class="form-group ">
        <label for="validade">Data validade</label>
        <kendo-dateinput name="validade" id="validade" format="MM/yy" class="form-control"  required #validade="ngModel"
                         [(ngModel)]="cartao.validade" data-pagarmecheckout-input>

        </kendo-dateinput>
        <div class="invalid-feedback">
          <p *ngIf="validade.errors?.required">Obrigatório</p>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-8" >
      <div class="form-group ">
        <label for="nome">Nome do titular</label>
        <input type="text" class="form-control" autocomplete="off" required data-pagarmecheckout-input
               id="nome" name="nome" [(ngModel)]="cartao.nome" #nome="ngModel"
               placeholder="Nome impresso" value="" >
        <div class="invalid-feedback">
          <p *ngIf="nome.errors?.required">Obrigatório</p>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-4" >
      <div class="form-group ">
        <label for="cvv">Código de segurança</label>
        <input type="text" class="form-control" autocomplete="off" [mask]="'0009'" placeholder="cod. segurança"
               id="cvv" name="cvv" [(ngModel)]="cartao.cvv" #cvv="ngModel" data-pagarmecheckout-input
               required    >
        <div class="invalid-feedback">
          <p *ngIf="cvv.errors?.required">Obrigatório</p>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-5" >
      <div class="form-group">
        <label for="nome">CPF</label>
        <input type="text" class="form-control" autocomplete="off" required data-pagarmecheckout-input
               id="cpf" name="cpf" [(ngModel)]="cartao.cpf" #cpf="ngModel"
               mask="000.000.000-00" cpfValido placeholder="___.___.___-__" value="">
        <div class="invalid-feedback">
          <p *ngIf="cpf.errors?.required">Obrigatório</p>
          <p *ngIf="cpf.errors?.cpfInvalido">CPF é invalido</p>
        </div>
      </div>
    </div>

   <div class="form-group  col-12 col-sm-7" >
      <label for="nome">Email</label>
      <input kendoTextBox id="email" name="email" type="email" emailPagamentoValido placeholder="Informe seu email"
             class="form-control"   #email="ngModel"
             [(ngModel)]="cartao.email" required/>

      <div class="invalid-feedback">
        <p *ngIf="email.errors?.required">Email é obrigatório</p>
        <p *ngIf="email.errors?.email || email.errors?.emailPagamentoInvalido">Informe um email válido.</p>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="parcelasValores.length > 1">
    <div class="form-group  col-12" >
      <label  >Número de parcelas</label>
      <kendo-combobox   #cboParcela="ngModel" class="form-control" name="parcelas"
                        [textField]="'descricao'" [valueField]="'id'" required
                        [(ngModel)]="parcela" [data]="parcelasValores"   placeholder="Selecione a quantidade de parcelas"     >
      </kendo-combobox>
      <div class="invalid-feedback">
        <p *ngIf="cboParcela.errors?.required">Obrigatorio</p>
      </div>
    </div>
  </div>


</form>

<div id="tdsMethodContainer" style="display: none;"></div>
<div id="challengeContainer"></div>

